import styled from "styled-components";
import { Disabled } from "styles/GlobalCss";
import { styled as muiStyled } from '@mui/material/styles';
import { Box } from "@mui/material";
import { borderRadius, fontWeight, maxHeight, positions, textAlign } from "@mui/system";


export const MarkingChatStyles = muiStyled(Box)(({ open = true }) => ({
    width: open ? 500 : 0,
    minWidth: open ? 500 : 0,
    padding: 7,
    paddingLeft: 15,
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.chat-responses': {
        display: "flex",
        height: "calc(100% - 130px)",
        flexDirection: "column",
        rowGap: 20,
        overflow: "auto"
    },
    '.write-message': {
        flexGrow: 1
    },
    '.chat-footer': {
        display: "flex",
        columnGap: 5,
        alignItems: "end",
        position: "absolute",
        bottom: 10,
        width: open ? 500 : 0
    },
    '.send-button': {
        width: 40,
        height: 55
    },
    'textarea': {
        textAlign: "start !important",
        padding: "10px !important",
        flexGrow: 1,
        maxHeight: 200,
        overflow: "auto"
    },
    '.sender-details': {
        display: "flex",
        flexDirection: "column"
    },
    '.created-by': {
        width: 200,
        display: "flex",
        rowGap: 5,
        columnGap: 7,
        alignItems: "center"
    },
    '.wrap-chat-message': {
        display: "flex",
        columnGap: 10
    },
    '.chat-title': {
        fontSize: 20,
        fontWeight: "bold",
        height: 40,
        display: "flex",
        justifyContent: "space-between"
    },
    '.chat-message': {
        width: "100%",
        background: "white",
        borderRadius: 8,
        padding: 12
    }
}));

export const MarkingWordsStyles = muiStyled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    display: "flex",
    '.redo-message': {
        paddingLeft: 10
    },
    '.words-and-buttons': {
        display: "flex",
        flexGrow: 1,
        overflow: "auto",
        flexDirection: "column"
    }
}));

export const StatusCellStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex"
}));


export const MarkingWordsHeaderStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between"
}));

const WrapFooter = styled.div`
display: flex;
justify-content: end;
column-gap: 10px;
height:70px;
align-items: center;
${props => props.$disabled && Disabled};
`

const WrapEndActions = styled.div`
display: flex;
column-gap: 10px;
`

const WrapHeader = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
`

const WrapActionBtn = styled.div`
width:${props => props.width}px;
height:30px;
`


export { WrapFooter, WrapActionBtn, WrapHeader, WrapEndActions }